<div style="position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; display: flex; flex-flow: column;">
    <clr-alert [clrAlertType]="'danger'" [clrAlertAppLevel]="true" *ngIf="failureMode && !isLoading">
        <clr-alert-item>
            <span class="alert-text">Cannot load data from DC Netscope API. Please check the diagnostic page.</span>
            <div class="alert-actions">
                <a routerLink="/diagnostic" routerLinkActive="active">
                    <button class="btn alert-action">
                        <cds-icon shape="checkbox-list"></cds-icon>
                        Diagnostic
                    </button>
                </a>
            </div>
        </clr-alert-item>
    </clr-alert>

    <clr-modal [(clrModalOpen)]="showFlowModal" [clrModalClosable]="true" [clrModalStaticBackdrop]="false" [clrModalSize]="'xl'">
        <div class="modal-body">
            <div class="clr-row">
                <div class="clr-col-12">
                    <h3>{{ selectFlowDetailsModalTitle }}</h3>
<!--                    <app-netscope-flows-datagrid-->
<!--                      [temporalParameter]="temporalParameter"-->
<!--                      [flowDetails]="selectFlowDetails"-->
<!--                      [exportCsvEnabled]="true"-->
<!--                      *ngIf="showFlowModal">-->
<!--                    </app-netscope-flows-datagrid>-->
                    <app-netscope-flows-datagrid
                      [thirdPartyRefresh]="flowsRepositoryModal?.refresh"
                      [flowsRepository]="flowsRepositoryModal"
                      [totalItemsCount]="flowsRepositoryModal?.totalItemsCount"
                      [switchFocus]="switchFocus"
                      [temporalParameter]="temporalParameter"
                      [exportCsvEnabled]="true"
                      [flowDetails]="flowsRepositoryModal.dashboardFlows"
                      *ngIf="showFlowModal">
                    </app-netscope-flows-datagrid>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="showFlowModal = false">
                Close
            </button>
        </div>
    </clr-modal>

    <div style="padding-right: 30px; padding-left: 30px;">
        <div class="clr-row">
            <div class="clr-col-12">
                <div class="card">
                    <div class="card-header">
                        Overall traffic
                    </div>
                    <div class="card-block">
                        <div class="card-title">
                        </div>
                        <div class="card-text">
                            <div echarts id="overall-traffic-chart" [options]="overallTrafficChartOptions" (chartClick)="onOverallTrafficChartClick($event)"
                                 (chartInit)="onOverallTrafficChartInit($event)"
                                 (chartBrushEnd)="onOverallTrafficChartBrushEnd($event)"
                                 (chartDataZoom)="onOverallTrafficChartDataZoom()"
                                 style="width: 100%; height: 400px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="clr-row">
            <div class="clr-col-4">
                <div class="card">
                    <div class="card-header">
                        Inside vs Outside infrastructure
                    </div>
                    <div class="card-block">
                        <div class="card-title">
                        </div>
                        <div class="card-text">
                            <div echarts id="origin-pie-chart" [options]="originPieChartOptions" (chartClick)="onOriginPieChartClick($event)"
                                 style="width: 100%; height: 400px;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clr-col-4">
                <div class="card">
                    <div class="card-header">
                        Protocols
                    </div>
                    <div class="card-block">
                        <div class="card-title">
                        </div>
                        <div class="card-text">
                            <div echarts id="protocol-pie-chart" [options]="protocolPieChartOptions" (chartClick)="onProtocolPieChartClick($event)"
                                 style="width: 100%; height: 400px;"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clr-col-4">
                <div class="card">
                    <div class="card-header">
                        Top 20 Emitters
                    </div>
                    <div class="card-block">
                        <div class="card-title">
                        </div>
                        <div class="card-text">
                            <div echarts id="emitter-pie-chart" [options]="emitterPieChartOptions" (chartClick)="onEmitterPieChartClick($event)"
                                 style="width: 100%; height: 400px;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="clr-row">
            <div class="clr-col-4">
                <div class="card" id="data-analysed-card">
                    <div class="card-block">
                        <h3 class="card-title">Data analysis</h3>
                        <p class="card-text">
                            {{ netscopeUtils.formatBytes(amountOfDataProcessed) }} analysed
                        </p>
                    </div>
                </div>
            </div>
            <div class="clr-col-4">
                <div class="card" id="packets-analysed-card">
                    <div class="card-block">
                        <h3 class="card-title">Packets analysis</h3>
                        <p class="card-text">
                            {{amountOfPacketsProcessed  | number: '1.0-0'}} packets analysed
                        </p>
                    </div>
                </div>
            </div>
            <div class="clr-col-4">
                <div class="card" id="flows-analysed-card">
                    <div class="card-block">
                        <h3 class="card-title">Flows analysis</h3>
                        <p class="card-text">
                            {{amountOfFlowsProcessed  | number: '1.0-0'}} flows analysed
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="clr-row">
            <div class="clr-col-12">
                <div class="card" style="margin-bottom: 15px;">
                    <div class="card-header">
                        Details of traffic
                    </div>
                    <div class="card-block" style="padding-top: 0px;">
                        <div class="card-title">
                        </div>
                        <div class="card-text">
                            <app-netscope-flows-datagrid
                              [thirdPartyRefresh]="flowsRepository?.refresh"
                              [flowsRepository]="flowsRepository"
                              [totalItemsCount]="flowsRepository?.totalItemsCount"
                              [switchFocus]="switchFocus"
                              [temporalParameter]="temporalParameter"
                              [exportCsvEnabled]="true"
                              [flowDetails]="flowsRepository?.dashboardFlows">
                            </app-netscope-flows-datagrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
